/* =============================================================
   ÉLAN BRUT — Theme JS v1.0
   Vanilla JS only — no jQuery, no frameworks
   ============================================================= */

(function () {
  'use strict';

  /* -------------------------------------------------------
     Utility: format money from cents
  ------------------------------------------------------- */
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency)
      ? window.Shopify.currency.active
      : 'USD';
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }

  /* -------------------------------------------------------
     Header: transparent → solid on scroll
  ------------------------------------------------------- */
  var header = document.getElementById('site-header');

  if (header) {
    function onScroll() {
      if (window.scrollY > 50) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -------------------------------------------------------
     Scroll Reveal via IntersectionObserver
  ------------------------------------------------------- */
  var revealEls = document.querySelectorAll('.reveal-item');

  if (revealEls.length) {
    if ('IntersectionObserver' in window) {
      var revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

      revealEls.forEach(function (el) { revealObs.observe(el); });
    } else {
      // Fallback: reveal immediately
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    }
  }

  /* -------------------------------------------------------
     Cart Drawer
  ------------------------------------------------------- */
  var cartDrawer     = document.getElementById('cart-drawer');
  var cartOverlay    = document.getElementById('cart-drawer-overlay');
  var cartBtn        = document.getElementById('cart-btn');
  var cartCloseBtn   = document.getElementById('cart-drawer-close');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartCloseBtn && cartCloseBtn.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartBtn && cartBtn.focus();
  }

  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      fetchCart().then(function (cart) {
        renderCartDrawer(cart);
        openCartDrawer();
      });
    });
  }

  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* -------------------------------------------------------
     Cart API helpers
  ------------------------------------------------------- */
  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .catch(function (err) { console.error('[ÉB] fetchCart:', err); return null; });
  }

  function updateCartCounters(count) {
    document.querySelectorAll('.cart-count, #cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function renderCartDrawer(cart) {
    var itemsEl    = document.getElementById('cart-drawer-items');
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    if (!itemsEl || !cart) return;

    updateCartCounters(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty">Nothing here yet.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var imgSrc = item.featured_image && item.featured_image.url
          ? item.featured_image.url
          : (item.image || '');
        var variantText = item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';
        return '<div class="cart-item" data-key="' + item.key + '">' +
          (imgSrc
            ? '<img src="' + imgSrc + '" alt="' + item.title + '" class="cart-item__img" width="70" loading="lazy">'
            : '<div class="cart-item__img"></div>') +
          '<div class="cart-item__info">' +
            '<div>' +
              '<p class="cart-item__title">' + item.product_title + '</p>' +
              (variantText ? '<p class="cart-item__variant">' + variantText + '</p>' : '') +
            '</div>' +
            '<div class="cart-item__bottom">' +
              '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
              '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove ' + item.product_title + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      itemsEl.querySelectorAll('.cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          removeCartItem(btn.dataset.key);
        });
      });
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCounters(cart.item_count);
      })
      .catch(function (err) { console.error('[ÉB] removeCartItem:', err); });
  }

  /* -------------------------------------------------------
     Add to Cart (AJAX)
  ------------------------------------------------------- */
  var addToCartForm = document.getElementById('add-to-cart-form');

  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var variantInput = addToCartForm.querySelector('[name="id"]');
      var addBtn       = addToCartForm.querySelector('.add-to-cart-btn');
      if (!variantInput || !variantInput.value) return;

      var originalText = addBtn ? addBtn.textContent : '';
      if (addBtn) {
        addBtn.classList.add('is-loading');
        addBtn.textContent = '—';
        addBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantInput.value, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add to cart failed');
          return fetchCart();
        })
        .then(function (cart) {
          if (cart) {
            renderCartDrawer(cart);
            openCartDrawer();
          }
        })
        .catch(function (err) { console.error('[ÉB] addToCart:', err); })
        .finally(function () {
          if (addBtn) {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }
        });
    });
  }

  /* -------------------------------------------------------
     Product Variant Selection
  ------------------------------------------------------- */
  var productForm = document.getElementById('add-to-cart-form');

  if (productForm) {
    var variantIdInput = productForm.querySelector('[name="id"]');
    var variantsDataEl = document.getElementById('product-variants-data');

    if (!variantIdInput || !variantsDataEl) return;

    var variants;
    try {
      variants = JSON.parse(variantsDataEl.textContent);
    } catch (e) {
      console.error('[ÉB] Could not parse variants:', e);
      return;
    }

    // Track selected option per position (1-indexed)
    var selectedOptions = {};

    // Seed from first-available variant
    var seedVariant = variants.find(function (v) { return v.available; }) || variants[0];
    if (seedVariant) {
      if (seedVariant.option1) selectedOptions[1] = seedVariant.option1;
      if (seedVariant.option2) selectedOptions[2] = seedVariant.option2;
      if (seedVariant.option3) selectedOptions[3] = seedVariant.option3;
    }

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (pos) {
          return v['option' + pos] === selectedOptions[pos];
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      // Update hidden input
      variantIdInput.value = variant.id;

      // Update price display
      var priceEl = document.getElementById('product-price');
      if (priceEl) {
        var priceHTML = '';
        if (variant.compare_at_price > variant.price) {
          priceHTML = '<s>' + formatMoney(variant.compare_at_price) + '</s> ' + formatMoney(variant.price);
        } else {
          priceHTML = formatMoney(variant.price);
        }
        priceEl.innerHTML = priceHTML;
      }

      // Update main image if variant has featured image
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) {
          mainImg.src = variant.featured_image.src;
        }
      }

      // Update add-to-cart button
      var addBtn = productForm.querySelector('.add-to-cart-btn');
      if (addBtn) {
        if (!variant.available) {
          addBtn.textContent = 'Sold Out';
          addBtn.disabled = true;
        } else {
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }
      }
    }

    // Wire up size buttons
    document.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.dataset.optionIndex, 10);
        document.querySelectorAll('.size-btn[data-option-index="' + pos + '"]')
          .forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedOptions[pos] = btn.dataset.value;

        var label = document.getElementById('selected-size-label');
        if (label) label.textContent = btn.dataset.value;

        updateUI(findVariant());
      });
    });

    // Wire up color swatches
    document.querySelectorAll('.color-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var pos = parseInt(swatch.dataset.optionIndex, 10);
        document.querySelectorAll('.color-swatch[data-option-index="' + pos + '"]')
          .forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        selectedOptions[pos] = swatch.dataset.value;

        var label = document.getElementById('selected-color-label');
        if (label) label.textContent = swatch.dataset.value;

        updateUI(findVariant());
      });
    });

    // Run once on load
    updateUI(findVariant());
  }

  /* -------------------------------------------------------
     Product gallery thumbnails
  ------------------------------------------------------- */
  var mainImage = document.getElementById('product-main-image');
  var thumbs    = document.querySelectorAll('.product-thumb');

  if (mainImage && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.alt;
      });
    });

    // Mark first thumb as active
    if (thumbs[0]) thumbs[0].classList.add('is-active');
  }

  /* -------------------------------------------------------
     Cart page: remove item
  ------------------------------------------------------- */
  document.querySelectorAll('.cart-page__item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error('[ÉB] cart remove:', err); });
    });
  });

})();
